module.exports = __webpack_public_path__ + "img/blog-2.ac76578e.jpg";